module.exports = __webpack_public_path__ + "static/media/x.bb9db21a.svg";